import { FILTER_TYPES } from 'components/FilterPod';

const GRANT = [
  {
    label: 'درخواست شده',
    value: 'FINANCIAL_PERMISSION_STATUS_REQUESTED',
  },
  {
    label: 'تایید شده',
    value: 'FINANCIAL_PERMISSION_STATUS_CONFIRMED',
  },
  {
    label: 'لغو شده',
    value: 'FINANCIAL_PERMISSION_STATUS_REVOKED',
  },
  {
    label: 'رد شده',
    value: 'FINANCIAL_PERMISSION_STATUS_REJECTED',
  },
  {
    label: 'حذف شده',
    value: 'FINANCIAL_PERMISSION_STATUS_DELETED',
  },
];

const GRANT_TYPE = [
  {
    label: 'فاکتور',
    value: 'FINANCIAL_OPERATION_INVOICE',
  },
  {
    label: 'انتقال وجه',
    value: 'FINANCIAL_OPERATION_TRANSFER',
  },
  {
    label: 'تسویه حساب',
    value: 'FINANCIAL_OPERATION_REQUEST_SETTLEMENT',
  },
  {
    label: 'موجودی حساب',
    value: 'FINANCIAL_OPERATION_GET_CREDIT',
  },
  {
    label: 'صورتحساب',
    value: 'FINANCIAL_OPERATION_ACCOUNT_BILL',
  },
];

const filters = (getAccounts) => [
  {
    title: 'براساس وضعیت مجوز',
    label: 'وضعیت مجوز',
    keyName: 'grantStatus',
    id: 0,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: GRANT,
    },
  },
  {
    title: 'براساس نوع مجوز',
    label: 'نوع مجوز',
    keyName: 'operationCode',
    id: 0,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: GRANT_TYPE,
    },
  },
];

export default filters;
